import { render, staticRenderFns } from "./purchaseRoute-add-or-update.vue?vue&type=template&id=c3b12716&scoped=true"
import script from "./purchaseRoute-add-or-update.vue?vue&type=script&lang=js"
export * from "./purchaseRoute-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./purchaseRoute-add-or-update.vue?vue&type=style&index=0&id=c3b12716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b12716",
  null
  
)

export default component.exports